// extracted by mini-css-extract-plugin
export default {"container":"_218LZ9fx","timetableWrapper":"_2DPt6yzu scrollable","modulesSelect":"f-RfwIQW col-12","moduleTableFooter":"_1Zb7XrMU"};